import { CardBody as _CardBody, CardBodyProps as _CardBodyProps } from "reactstrap";

    export const CardBody = _CardBody;
    export type CardBodyProps = _CardBodyProps;
    